import React, { useState, useEffect } from "react";
import styles from "./SmartAppBanner.module.scss";
import { ReactComponent as XIcon } from "assets/img/close.svg";
import { useAtom } from "jotai";
import { showBannerAtom } from "showMessageMenuAtom";
// import useMobileScrollBanner from "hooks/useMobileScrollBanner/useMobileScrollBanner";

const SmartAppBanner = () => {
  const [appLink, setAppLink] = useState<any>(null);
  const [showBanner, setShowBanner] = useAtom(showBannerAtom);
  //  const showBannerOnScroll: any = useMobileScrollBanner();

  const userAgent = navigator.userAgent;

  // Call this when user dismisses the banner
  function dismissSmartBanner(): void {
    localStorage.setItem("appBannerDismissedTimestamp", Date.now().toString());
  }

  useEffect(() => {
    const isIOS = /iPhone|iPad|iPod/.test(userAgent) ||
      (/Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1);
    const isAndroid = /Android/i.test(userAgent);

    // Additional check to exclude desktop browsers in mobile mode
    const isDesktopBrowser = /Chrome|Firefox|Safari|Edge/i.test(userAgent) &&
      !/Mobile|Android|iPhone|iPad|iPod/i.test(userAgent);

    const isMobileDevice = (isIOS || isAndroid) && !isDesktopBrowser;


    // If not on mobile device, don't show banner
    if (!isMobileDevice) {
      setShowBanner(false);
      return;
    }

    // Check if banner was previously dismissed
    const wasBannerDismissed = localStorage.getItem("appBannerDismissed") === "true";

    // If banner wasn't dismissed or we're checking the initial state
    if (!wasBannerDismissed) {
      setShowBanner(true);

      // Set appropriate app store link based on device
      if (isIOS) {
        setAppLink("https://apple.co/3PBYiVB");
      } else {
        setAppLink("https://bit.ly/3LovhKx");
      }
    } else {
      setShowBanner(false);
    }
  }, []);

  const handleDismiss = () => {
    dismissSmartBanner();
    setShowBanner(false);
    localStorage.setItem("appBannerDismissed", "false");
  };

  if (!showBanner || window.location.pathname === '/signup') return null;

  return (
    <div className={styles.banner} id='SmartAppBanner'>
      <div>
        <button onClick={handleDismiss} className={styles.dismissButton}>
          <XIcon />
        </button>
        <a href={appLink}>
          <div className={styles.banner__top}>
            <img src="https://static.group.app/assets/icons/ic_launcher.png" alt="GroupApp communities" />
            <div>
              <h1>GroupApp Communities  </h1>
              <p>Your communities on the go</p>
            </div>
          </div>
          <span className={styles.banner__top__appLink}>
            Download App
          </span>
        </a>

      </div>
    </div>
  );
};

export default SmartAppBanner;
